import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义主题
import 'element-ui/lib/element-#49D292/index.css'

Vue.use(Element)
